<div class="container-fluid wrapper-page">
  <div class="page-head">
    <h5 class="header-title heading-color">CheckIn Detail</h5>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body">

          <!-- DISPLAY PATIEN DETAILS Starts-->

          <div class="container-fluid">
            <div class="bg-primary text-white p-1">
              <h5 class="mt-2 ml-4">PATIENT PROFILE</h5>
            </div>
            <div class="card m-b-30">
              <div class="card-body">
                <div class="col-md-12 d-flex">
                  <div class="col-md-3 mt-4">
                    <img src="{{p_purl}}" onerror="this.src='assets/new-ui/images/users/avatar.jpg'" class="image">

                  </div>
                  <div class="col-md-4">
                    <div class="row marBt5">
                      <div class="col-5">
                        <label class="label1">Name:</label>
                      </div>
                      <div class="col-7">
                        <label class="label2">{{p_first_name}} {{p_last_name}}</label>
                      </div>
                    </div>
                    <!-- <div class="row marBt5">
                        <div class="col-5">
                          <label class="label1">Patient ID:</label>
                        </div>
                        <div class="col-7">
                          <label class="label2">{{pat.pid}}</label>
                        </div>
                      </div>
                      <div class="row marBt5">
                        <div class="col-5">
                          <label class="label1">Height (Cms):</label>
                        </div>
                        <div class="col-7">
                          <label class="label2">{{pat.height}}</label>
                        </div>
                      </div>
                      <div class="row marBt5">
                        <div class="col-5">
                          <label class="label1">Weight (Kgs):</label>
                        </div>
                        <div class="col-7">
                          <label class="label2">{{pat.weight}}</label>
                        </div>
                      </div> -->
                    <div class="row">
                      <div class="col-5">
                        <label class="label1">Email:</label>
                      </div>
                      <div class="col-7 customa">
                        <label class="label2">{{p_email_id}}</label>
                      </div>
                    </div>
                    <div class="row marBt5">
                      <div class="col-5">
                        <label class="label1">Gender:</label>
                      </div>
                      <div class="col-7">
                        <label class="label2">{{p_gender}}</label>
                      </div>
                    </div>
                    <div class="row marBt5">
                      <div class="col-5">
                        <label class="label1">Date of Birth:</label>
                      </div>
                      <div class="col-7">
                        <label class="label2">{{p_dob | date:'dd-MM-yyyy'}}</label>
                      </div>
                    </div>
                    <div class="row marBt5">
                      <div class="col-5">
                        <label class="label1">Address:</label>
                      </div>
                      <div class="col-7">
                        <label class="label2">{{p_address_1?.p_address_1}} {{p_address_2?.p_address_2}}
                          {{p_city_n}} {{p_state}}</label>
                      </div>
                    </div>
                    <div class="row marBt5">
                      <div class="col-5">
                        <label class="label1">Contact No:</label>
                      </div>
                      <div class="col-7">
                        <label class="label2">{{p_contact_no}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="row marBt5">
                      <div class="col-7">
                        <label class="label1">Patient Since:</label>
                      </div>
                      <div class="col-5">
                        <label class="label2">{{since | date:'yyyy'}}</label>
                      </div>
                    </div>
                    <div class="row marBt5">
                      <div class="col-7">
                        <label class="label1">Drug Allergies:</label>
                      </div>
                      <div class="col-5">
                        <label class="label2">{{patient?.allergy?patient.allergy:'--'}}</label>
                      </div>

                    </div>
                    <div class="row marBt5">
                      <div class="col-7">
                        <label class="label1">Last Consultation Date:</label>
                      </div>
                      <div class="col-5">
                        <label class="label2">{{p_pre_consultdate | date:'dd-MM-yyyy'}}</label>
                      </div>
                    </div>
                    <div class="row marBt5">
                      <div class="col-7">
                        <label class="label1">Last follow-up request on:</label>
                      </div>
                      <div class="col-5">
                        <label class="label2">{{p_pre_followdate | date:'dd-MM-yyyy'}}</label>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- DISPLAY PATIEN DETAILS ENDS-->
          <div class="container-fluid ">
            <div class="bg-primary text-white p-1">
              <h5 class="mt-2 ml-4">REASON FOR VISIT</h5>
            </div>
            <div class="card m-b-30">
              <div class="card-body">
                <div class="row nested-col col-sm-12 mx-auto">
                  <div class="col-sm-2"></div>
                  <div class="col-sm-8">

                    <form [formGroup]="forms['reasonForm']">

                      <textarea name="reasons" class="form-control" formControlName="reasons" rows="4"
                        value="{{reason}}"></textarea>
                      <!-- <button type="button" class="btn btn-primary rondBrtn" name="submit"
                              (click)="submitreasonForm(reasonForm.value)">SUBMIT
                              RECORD</button> -->

                    </form>

                  </div>
                  <div class="col-sm-2"></div>
                </div>
              </div>
            </div>

            <!-- PATIENT STATISTICS STARTS -->
            <div class="container-fluid ">
              <div class="bg-primary text-white p-1">
                <h5 class="mt-2 ml-4">PATIENT HEALTH STATISTICS</h5>
              </div>
              <div class="card m-b-30">
                <div class="card-body">
                  <section class="mt-35 ml-2 align-items-center">
                    <form [formGroup]="forms['patstats']">

                      <ul class="ul1">
                        <li class="li1" formArrayName="pat_stats"
                          *ngFor="let item of forms['patstats']?.get('pat_stats')['controls']; let i = index;">
                          <div class="row" [formGroupName]="i">
                            <div class="col-md-12 d-flex">
                              <div class="col-sm-6 col-md-4 mt-3 mb-2">
                                <label>{{getStatsLabel(i)}}</label>
                              </div>

                              <div class="col-sm-6 col-md-3  mb-2 ">
                                <input formControlName="stats_value" placeholder="" name="stats_value" type="text"
                                  class="form-control">
                                <div *ngIf="getStatsLabel(i) === getStatsLabel(2) ">
                                  <label class="font-italic text-danger">eg:Systolic / Diastolic</label>
                                </div>
                              </div>

                              <div class="col-sm-6 mt-3 col-md-3 "><span class=" mt-3"
                                  style="font-size: 12px;">{{getStatsuom(i)}}</span></div>
                            </div>
                            <div class="col-sm-6 col-md-2 mt-3"></div>
                          </div>
                        </li>
                        <li class="li1" *ngIf="forms['patstats']?.get('pat_stats')['controls']?.length % 2 != 0"></li>
                      </ul>




                      <!-- <div class="row cust_row habits">
                      <div class="form-group" formArrayName="pat_stats"
                        *ngFor="let item of forms['patstats'].get('pat_stats')['controls']; let i = index;">
                        <div class="row" [formGroupName]="i" class="width-100">
                          <div class="row">
                            <div class="col-12 col-sm-8 col-md-3 m-m margin-top-15"></div>
                            <div class="col-12 col-sm-8 col-md-3 m-m margin-top-15">
                              <label for="" class="mt-3">{{getStatsLabel(i)}}</label>
                            </div>

                            <div class="col-12 col-sm-4 col-md-3">

                              <input formControlName="stats_value" type="text" class="form-control">
                            </div>
                            <div class="col-12 col-sm-8 col-md-3 m-m margin-top-15"></div>
                          </div>
                        </div>
                      </div>
                    </div> -->


                    </form>
                    <!-- <button type="button" class=" btn btn-primary button1 " (click)="savestats()">Check-In</button> -->
                  </section>
                </div>
              </div>

            </div>
            <!-- PATIENT STATISTICS ENDS -->


            <!-- GENERIC DOCUMENTS UPLOAD and DISPLAY STARTS -->
            <div class="container-fluid ">

              <div class="bg-primary text-white p-1">
                <h5 class="mt-2 ml-4">UPLOAD DOCUMENTS<span class="font-italic font-size-14 ml-2">(Upto 10 documents
                    can be
                    uploaded,File size not to exceed 2 MB)</span></h5>
              </div>
              <div class="card m-b-30">
                <div class="card-body">
                  <form [formGroup]="forms['documentsForm']">

                    <div class="form-group" formArrayName="documents" *ngFor="
                        let item of forms['documentsForm'].get('documents')[
                          'controls'
                        ];
                        let i = index
                      ">
                      <div class="row d-flex" [formGroupName]="i">
                        <div class="col-md-4">
                          <input type="text" class="form-control text-dark" formControlName="description"
                            name="description" form placeholder="Enter description"
                            [readonly]="documents?.at(i).get('readOnly').value" />
                          <div *ngIf="
                              documents?.at(i).get('description') &&
                              documents
                                ?.at(i)
                                .get('description')
                                .hasError('required')
                            " class="invalid-feedback">
                            This is required
                          </div>
                        </div>

                        <div class="col-md-4" *ngIf="!documents?.at(i).get('readOnly').value">
                          <input #inputFile class="form-control text-dark" type="file"
                            accept="application/pdf, png,jpeg,jpg" (change)="selectFile($event, i)"
                            placeholder="Select file" />
                          <div class="font-color label-text font-size-10 font-weight-400">
                            eg. pdf, jpeg, png
                          </div>
                          <div *ngIf="
                              documents?.at(i).get('name') &&
                              documents?.at(i).get('name').hasError('required')
                            " class="invalid-feedback">
                            This is required
                          </div>
                        </div>

                        <div class="col-md-4" *ngIf="documents?.at(i).get('readOnly').value">
                          <input class="form-control text-dark" type="text" readonly formControlName="name"
                            name="name" />
                        </div>
                        <div class="col-md-2" *ngIf="!documents?.at(i).get('readOnly').value">
                          <button type="button" class="form-control btn btn-primary btn-doctor"
                            [disabled]="!documents?.at(i).get('name').value" (click)="previewDocument(i)">
                            Preview
                          </button>
                        </div>

                        <div class="col-4 col-sm-2 col-md-1 m-m text-right"
                          *ngIf="!documents?.at(i).get('readOnly').value">
                          <button *ngIf="i >= 0" type="button" class="btn btn-outline-primary removeitem"
                            style="padding: 12px 16px" (click)="removingCurrentDocument(i)">
                            <i class="fa fa-close"></i>
                          </button>
                        </div>

                        <div class="col-4 col-sm-2 col-md-1 m-m text-right"
                          *ngIf="!documents?.at(i).get('readOnly').value">
                          <button type="button" class="btn btn-outline-primary addmore" style="padding: 12px 16px"
                            (click)="addingDocument(i)">
                            <i class="fa fa-plus"></i>
                          </button>
                        </div>

                      </div>
                    </div>

                    <!-- <button *ngIf="!disableSubmit" type="button" class="btn btn-primary btn-doctor pull-right"
                    [disabled]="forms['documentsForm'].invalid" (click)="saveDocuments()">Upload Documents</button> -->

                  </form>
                </div>
              </div>
            </div>
            <!-- GENERIC DOCUMENTS UPLOAD and DISPLAY ENDS -->


            <!--  PRESCRIBED LAB REQUEST STARTS -->
            <div class="container-fluid ">
              <!-- <div class="bottomForm">
                <div class="row"> -->
              <div class="bg-primary text-white p-1">
                <h5 class="mt-2 ml-4">PRESCRIBED LAB REQUESTS</h5>
              </div>
              <div class="card-body-1 table-responsive">
                <div class="card m-b-30">
                  <div class="card-body">
                    <div class="col-sm-12 table-responsiv">
                      <table id="datatable2" class="table dataTable no-footer" role="grid"
                        aria-describedby="datatable2_info">
                        <thead>
                          <tr role="row">
                            <th class="sorting_asc" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                              aria-sort="ascending" aria-label="Name: activate to sort column descending"
                              style="width: 16%">
                              Date
                            </th>
                            <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                              aria-label="Position: activate to sort column ascending" style="width: 16%">
                              Name of test
                            </th>
                            <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                              aria-label="Office: activate to sort column ascending" style="width: 20%">
                              Remarks
                            </th>
                            <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                              aria-label="Age: activate to sort column ascending" style="width: 16%">
                              Status
                            </th>
                            <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                              aria-label="Age: activate to sort column ascending" style="width: 22%">
                              Attachment
                            </th>
                            <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                              aria-label="Age: activate to sort column ascending" style="width: 10%">
                              Action
                            </th>
                          </tr>
                        </thead>

                        <tbody *ngFor="let record of testsList">
                          <tr role="row" class="odd" *ngIf="record.tstat !== 'Reviewed' ">
                            <td>
                              {{ record.tdate | date: "dd-MM-yyyy" }}
                            </td>
                            <td>
                              {{ record.labtest_name }}
                              <input type="hidden" name="testid" value="record.testid" />
                            </td>
                            <td>{{ record.remarks }}</td>
                            <td>{{ record.tstat }}</td>
                            <td>
                              <div class="gridimg" *ngFor="
                            let report of record.attachments;let i=index;
                          ">
                                <div *ngIf="record.attachments.ext[i]!='' && record.attachments.ext[i]=='pdf'">
                                  <!-- <a [href]="report" target="_blank"> -->
                                  <a class="cursor" (click)="previewDocuments(report)">
                                    <span class="fa-stack fa-lg">
                                      <i class="fa fa-circle fa-stack-2x"></i>
                                      <i class="fa fa-file-pdf-o fa-stack-1x fa-inverse"></i>
                                    </span>
                                  </a>
                                </div>
                                <div *ngIf="record.attachments.ext[i]!='' &&  record.attachments.ext[i]!='pdf'">
                                  <a class="cursor" (click)="previewDocuments(report)"> <img [src]="report"
                                      style="width: 30px;height:30px; border-radius:50%;max-width:100%;cursor:pointer"
                                      class=" modal-hover-opacity" data-toggle="modal" data-target="#myModal" />
                                  </a>
                                </div>
                              </div>
                            </td>
                            <td>

                              <a (click)="openEditLabTest(labTestModal,record)">
                                <i class="fa fa-paperclip" style="font-size:24px"></i>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </div>
                </div>
                <!-- </div>
                </div> -->
              </div>
            </div>
            <!--  PRESCRIBED LAB REQUEST ENDS -->
            <!--  create Inperson video STARTS -->
            <div class="container-fluid " *ngIf="online_checkin">
              <div class="bg-primary text-white p-1">
                <h5 class="mt-2 ml-4">CREATE ONLINE CONSULTATION</h5>
              </div>
              <div class="card-body-1 table-responsive">
                <div class="card m-b-30">
                  <div class="card-body">
                    <div class="col-sm-12 table-responsiv">

                      Your appointment is on {{aptdate| date}} between {{ aptime }} and {{ endtime }}. Would you like to
                      create an online meeting?

                      <button type="button" class="tabledit-edit-button btn btn-sm btn-info"
                        style="float: none; margin: 5px;" [disabled]="linksent"
                        (click)="createRoom();this.disabled=true; this.value='Sending…';">YES
                      </button>

                      <button type="button" class="tabledit-edit-button btn btn-sm btn-info"
                        style="float: none; margin: 5px;" [routerLink]="['/appointments/Checkin/edit/' + aid]">
                        <span class="ti-pencil"></span>
                      </button>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--  create Inperson video ENDS -->
            <div class="col-lg-8 ">
              <button type="button" class=" btn btn-info button1 " (click)="goBack()">Back</button>
              <button type="button" class=" btn btn-primary button1" *ngIf="!disableSubmit"
                (click)="statuscheck()">Check-In</button>
              <!-- <button type="button" class=" btn btn-primary button1 " routerLink="/appointments/Checkout"
                *ngIf="!disableSubmit" (click)="saveDocuments();savestats();statuscheck()">Check-In</button> -->
              <!-- <button type="button" class="btn btn-primary button1" (click)="savestats()">Check-In</button> -->
            </div>

          </div>
        </div>

      </div>
      <!-- Modal for preview docs -->




      <!--new changes -->
      <ng-template #PDFModal>
        <div>
          <div class="modal-header">
            <button type="button" class="close" (click)=closeModal()>&times;</button>
          </div>
          <div>
            <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block;"></pdf-viewer>
          </div>
        </div>
      </ng-template>




      <!-- ============== MODAL ================== -->
      <ng-template #labTestModal let-modal>
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">
            {{selectedLabTest.labtest_name}}
            <span>Test Date: {{selectedLabTest.tdate| date:'dd-MM-yyyy'}}</span>
          </h5>
          <!-- <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button> -->
        </div>


        <form [formGroup]="modalForm">
          <div class="modal-body">
            <div class="gridimg_modal" formArrayName="report_attachments"
              *ngFor="let record of modalForm.get('report_attachments')['controls']; let i=index;">

              <div [formGroupName]="i">
                <!-- {{report_attachments.controls[i].get('s3Key').value.split('?')[0].split('.').pop()}} -->

                <div *ngIf="report_attachments.controls[i].get('s3Key').value.split('?')[0].split('.').pop()=='pdf'">
                  <a [href]="report" target="_blank">
                    <span class="fa-stack fa-lg">
                      <i class="fa fa-circle fa-stack-2x"></i>
                      <i class="fa fa-file-pdf-o fa-stack-1x fa-inverse"></i>
                    </span>
                  </a>
                  <!-- <i (click)="deleteAttachment(i)" class="fa fa-trash trash-icon"></i> -->
                </div>

                <div *ngIf="report_attachments.controls[i].get('s3Key').value.split('?')[0].split('.').pop()!='pdf'">
                  <img [src]="report_attachments.controls[i].get('s3Key').value"
                    style="width: 50px;height:50px; border-radius:50%;max-width:100%;cursor:pointer" />
                  <!-- <i (click)="deleteAttachment(i)" class="fa fa-trash trash-icon"></i> -->
                </div>


              </div>


            </div>
            <br /><br />
            <label for="reportsRef">
              <input class="form-control text-dark" type="file" id="reportsRef" accept="application/pdf, image/*"
                #reportsRefImage (change)="uploadReports($event.target.files)" multiple>
            </label>
          </div>
        </form>


        <div class=" modal-footer">
          <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Cross click')">Cancel</button>
          <button type="button" class="btn btn-primary" [disabled]="files.length > 0"
            (click)="updateLabTest(modalForm.value);modal.dismiss('Cross click')">Update
            Report</button>
        </div>
      </ng-template>
      <!-- ======================================= -->

      <!-- ============== MODAL ================== -->
      <!-- <ng-template #labTestModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">
      {{ selectedLabTest.labtest_name }}
      <span>Test Date: {{ selectedLabTest.tdate | date: "dd-MM-yyyy" }}</span>
    </h5>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form [formGroup]="modalForm">
    <div class="modal-body">
      <div class="row">
        <div class="col-sm-6 mleft">
          <div class="remark">
            <h6>Update remark and submit review</h6>
            <input type="hidden" formControlName="testid" />
            <div class="form-group">
              <textarea formControlName="review" id="review" class="textareafield" placeholder="Review"></textarea>
            </div>
            <div class="form-group">
              <textarea formControlName="remarks" id="remarks" class="textareafield" placeholder="Remarks"></textarea>
            </div>
          </div>
        </div>
        <div class="col-sm-6 mright">
          <h6>Click to zoom attachment</h6> 
          <div class="form-group" formArrayName="report_attachments" *ngFor="
              let record of modalForm.get('report_attachments')['controls'];
              let i = index
            ">
            <div [formGroupName]="i" class="imglist">
              <img [src]="report_attachments.controls[i].get('s3Key').value" alt="" />

              <i (click)="deleteAttachment(i)" class="fa fa-trash trash-icon"></i>
            </div>
          </div>
          <div class="imglist newattach">
            <label for="reportsRef">
              <img src="https://cdn4.iconfinder.com/data/icons/twitter-28/512/170_Attachment_Binder_Clip_Paper-512.png"
                alt="" /></label>
            <input type="file" id="reportsRef" [accept]="allowedReportTypes" #reportsRefImage
              (change)="uploadReports($event.target.files)" multiple style="opacity: 0" />
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Cross click')">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
      (click)="updateLabTest(modalForm.value); modal.dismiss('Cross click')">
      Update Report
    </button>
  </div>
</ng-template> -->
      <!-- ======================================= -->